var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { html, LitElement } from "lit";
import { customElement, property, state } from "lit/decorators.js";
const customEl = "stepper-list";
let StepperList = class StepperList extends LitElement {
    constructor() {
        super(...arguments);
        this.duration = 5; // seconds
        this._activateNext = () => {
            const currIndex = this._steps?.findIndex((step) => step === this._activeStep);
            const nextIndex = (this._steps.length <= currIndex + 1)
                ? 0
                : currIndex + 1;
            this._deactivateStep(this._activeStep);
            this._activateStep(this._steps[nextIndex]);
        };
        this._handleMouseEnter = (event) => {
            const target = this._getEventTarget(event);
            if (this._activeStep !== target)
                return this._enteredWhenActive = false;
            this._deactivateStep(target, true);
            this._enteredWhenActive = true;
        };
        this._handleMouseLeave = (event) => {
            const target = this._getEventTarget(event);
            if (this._activeStep === target && this._enteredWhenActive) {
                this._activateStep(target);
            }
            this._enteredWhenActive = undefined;
        };
        this._handleClick = (event) => {
            const target = this._getEventTarget(event);
            if (this._activeStep === target)
                return;
            this._enteredWhenActive = true;
            this._deactivateStep(this._activeStep);
            this._activateStep(target, false);
        };
        this._getEventTarget = (event) => event.composedPath().find((el) => el.dataset && "step" in el.dataset);
    }
    render() {
        return html ``;
    }
    createRenderRoot() {
        return this;
    }
    connectedCallback() {
        super.connectedCallback();
        this._steps = [
            ...this.querySelectorAll("[data-step]") ??
                undefined,
        ];
        if (this._steps.length === 0)
            return;
        this._steps?.forEach((step) => {
            let bar = step.querySelector("stepper-bar");
            if (!bar) {
                bar = document.createElement("stepper-bar");
                step.appendChild(bar);
            }
            step._bar = bar;
            step.addEventListener("mouseenter", this._handleMouseEnter);
            step.addEventListener("mouseleave", this._handleMouseLeave);
            step.addEventListener("click", this._handleClick);
        });
        const activeStep = this._steps.filter((step) => "active" in step.dataset)
            .shift();
        const index = activeStep
            ? this._steps.findIndex((step) => step === activeStep)
            : 0;
        this._activateStep(this._steps[index]);
    }
    disconnectedCallback() {
        clearTimeout(this._timeout);
        clearInterval(this._interval);
        this._steps?.forEach((step) => {
            step.removeEventListener("mouseenter", this._handleMouseEnter);
            step.removeEventListener("mouseleave", this._handleMouseLeave);
            step.removeEventListener("click", this._handleClick);
        });
        super.disconnectedCallback();
    }
    _activateStep(step, withTimers = true) {
        step.dataset.active = "";
        this._activeStep = step;
        this._dispatchActiveStepEvent();
        if (withTimers)
            this._timeout = this._setTimeout();
        if (step._bar) {
            step._bar.progress = 0;
            if (withTimers)
                this._interval = this._setInterval(step._bar);
        }
    }
    _deactivateStep(step, temporarily = false) {
        if (step._bar)
            this._interval = this._clearInterval();
        this._timeout = this._clearTimeout();
        if (!temporarily) {
            this._activeStep = undefined;
            delete step.dataset.active;
        }
    }
    _dispatchActiveStepEvent() {
        const event = new CustomEvent("step", {
            bubbles: true,
            composed: true,
            detail: { step: this._activeStep },
        });
        this.dispatchEvent(event);
    }
    _setTimeout() {
        return setTimeout(this._activateNext, this.duration * 1000);
    }
    _clearTimeout() {
        clearTimeout(this._timeout);
        return undefined;
    }
    _setInterval(bar) {
        // TODO: migrate to RAF
        this._startTime = Date.now();
        return setInterval(() => bar.progress = this._intervalIteration(), 16);
    }
    _intervalIteration() {
        const elapsedTime = Date.now() - this._startTime;
        const percentage = Math.min(100, Math.ceil(elapsedTime / (this.duration * 1000) * 100));
        if (percentage >= 100)
            this._interval = this._clearInterval();
        return percentage;
    }
    _clearInterval() {
        this._startTime = undefined;
        clearInterval(this._interval);
        return undefined;
    }
};
__decorate([
    property(),
    __metadata("design:type", Object)
], StepperList.prototype, "duration", void 0);
__decorate([
    state(),
    __metadata("design:type", Array)
], StepperList.prototype, "_steps", void 0);
__decorate([
    state(),
    __metadata("design:type", void 0)
], StepperList.prototype, "_timeout", void 0);
__decorate([
    state(),
    __metadata("design:type", void 0)
], StepperList.prototype, "_interval", void 0);
__decorate([
    state(),
    __metadata("design:type", Number)
], StepperList.prototype, "_startTime", void 0);
__decorate([
    state(),
    __metadata("design:type", HTMLElement)
], StepperList.prototype, "_activeStep", void 0);
__decorate([
    state(),
    __metadata("design:type", Boolean)
], StepperList.prototype, "_enteredWhenActive", void 0);
StepperList = __decorate([
    customElement(customEl)
], StepperList);
export { StepperList };
